import { Center, Circle, Square } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
const CUICenter = args => {
  return /*#__PURE__*/_jsx(Center, Object.assign({}, args));
};
export const CUICircle = Circle;
export const CUISquare = Square;
export default CUICenter;